import { applyMiddleware, compose, createStore } from "redux";
import { createLogger } from 'redux-logger'
import thunk from "redux-thunk";
import reducer from './reducers/Reducers';

const loggerMiddleware = createLogger();
//const middlewares = [thunk, loggerMiddleware];
const middlewares = [thunk];

export default createStore(
    reducer,
    {},
    compose(applyMiddleware(...middlewares),
        //window.devToolsExtension ? window.devToolsExtension() : f => f
        //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
);